import React from 'react'
import { List, ListItem, ListItemButton, IconButton } from '@mui/material';
import { Trash2 } from 'react-feather'

export const PermissionList = ({ permissions, level = 0, handleChangePermissionAssignment }) => {
    return (
        <List style={{ paddingLeft: `${level * 20}px` }}>
            {permissions.map((permiso) => (
                <>
                    <ListItem  key={permiso.idpermiso} 
                        disablePadding
                        // secondaryAction={
                        //     <IconButton edge="end" aria-label="delete" onClick={()=>handleClickDeleteData(permiso.idpermiso)} >
                        //         <Trash2 />
                        //     </IconButton>
                        // }
                    >
                        <ListItemButton>
                            {(permiso.nivel === 2) && (
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={permiso.is_assigned}
                                        onChange={() => handleChangePermissionAssignment('permissionsAssigned', permiso.idpermiso)}
                                    />
                                    &nbsp;{permiso.nombrepermisos}
                                </label>
                            )}
                            {(permiso.nivel === 3) && (
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={permiso.is_assigned}
                                        onChange={() => handleChangePermissionAssignment('permissionsAssigned', permiso.idpermiso)}
                                    />
                                    &nbsp;<i>{permiso.nombrepermisos}</i>
                                </label>
                            )}
                        </ListItemButton>
                    </ListItem>
                    {permiso.hijos && permiso.hijos.length > 0 && (
                        <PermissionList permissions={permiso.hijos} level={level + 1} handleChangePermissionAssignment={handleChangePermissionAssignment}/>
                    )}
                </>
            ))}
        </List>
    );
}
